import styled, { css } from 'styled-components';

import { YatLogo } from '@pkg/assets/brand';

export const Root = styled.div`
    &&& {
        box-sizing: border-box;
        position: relative;
        display: inline-flex;
        vertical-align: middle;
        flex-shrink: 0;
    }
`;

type ContainerProps = {
    $border?: boolean;
    $variant?: 'home';
};

export const Container = styled.div<ContainerProps>`
    &&& {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        line-height: 1;
        border-radius: 50%;
        overflow: hidden;
        user-select: none;
        aspect-ratio: 1/1;
        background-color: ${({ theme }) => theme.shades.white[10]};

        ${({ $variant }) => {
            switch ($variant) {
                case 'home': {
                    return css`
                        width: 32px;
                        height: 32px;
                        font-size: 1rem;

                        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                            width: 90px;
                            height: 90px;
                            font-size: 2.0625rem;
                        }
                    `;
                }
                default: {
                    return css`
                        width: 40px;
                        height: 40px;
                        font-size: 1.3125rem;

                        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                            width: 100px;
                            height: 100px;
                            font-size: 2.6875rem;
                        }

                        @media (min-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
                            width: 135px;
                            height: 135px;
                            font-size: 3.6875rem;
                        }
                    `;
                }
            }
        }}

        ${({ $border }) =>
            $border &&
            css`
                border: 1px solid rgba(255, 255, 255, 0.1);
            `}
    }
`;

export const Image = styled.img`
    &&& {
        width: 100%;
        height: 100%;
        text-align: center;
        object-fit: cover;
    }
`;

export const StyledYatHand = styled(YatLogo)`
    &&& {
        display: inline-block;
        flex-shrink: 0;
        vertical-align: middle;
        overflow: hidden;
        fill: currentColor;
        box-sizing: border-box;
        width: auto;
        height: 1em;
        user-select: none;
        line-height: 1;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            margin-right: -6px; // visually center the hand
        }
    }
`;

export const BadgeWrapper = styled.div`
    &&& {
        position: absolute;
        bottom: 0;
        right: 0;
        display: inline-flex;

        svg {
            display: inline-block;
            flex-shrink: 0;
            vertical-align: middle;
            overflow: hidden;
            fill: currentColor;
            box-sizing: border-box;
            width: auto;
            height: 1em;
            user-select: none;
            line-height: 1;

            font-size: 0.625rem;

            @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                font-size: 1.25rem;
            }
        }
    }
`;
